import BarcodeViewer from './BarcodeViewer';
import QRCodeViewer from './QRCodeViewer';

export default Object.assign(
  {},
  {
    Barcode: BarcodeViewer,
    QRCode: QRCodeViewer,
  },
);
